<template>
	<detail :is-edit="true" />
</template>

<script>
	import Detail from './component/Detail'
	
	export default{
		name: 'EditUser',
		components: {Detail}
	}
</script>